import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EmployeeWithRoles } from '@core/models';
import { position, onDragEnded } from '@shared/helpers/dialog-drag-constraints';

@Component({
    selector: 'app-view-employee-roles',
    templateUrl: './view-employee-roles.component.html',
    styleUrls: ['./view-employee-roles.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ViewEmployeeRolesComponent implements OnInit {
  static readonly componentName = 'ViewEmployeeRolesComponent';
  
  public position = position;
  public onDragEnded = onDragEnded;

  constructor(
    @Inject(MAT_DIALOG_DATA) 
    public data: { 
      showEmployer: boolean, 
      ee: EmployeeWithRoles, 
      sysText: any;
    },
    private dialogRef: MatDialogRef<ViewEmployeeRolesComponent>,
  ) { }

  ngOnInit(): void {
  }
}
